import { ApiResponse, query } from './api';
import { putTelephoneNumberQuery } from './telephoney.query';
import { ChangePhoneNumberSuccess } from './telephoney.types';

export interface TelephonyApiInterface {
  changePhoneNumber(
    billingCustomerId: string,
    assignedProductId: string
  ): Promise<ApiResponse<ChangePhoneNumberSuccess>>;
}

export const TelephonyApi: TelephonyApiInterface = {
  async changePhoneNumber(
    billingCustomerId: string,
    assignedProductId: string
  ): Promise<ApiResponse<ChangePhoneNumberSuccess>> {
    const response = await query<{ putTelephoneNumber: ChangePhoneNumberSuccess }>({
      query: putTelephoneNumberQuery,
      variables: { billingCustomerId, assignedProductId },
      name: 'putTelephoneNumber',
    });

    return {
      data: response.putTelephoneNumber,
    };
  },
};
